import { values } from './constants'

export default class ViewerCounterHelper {
  static valueRounder = (value: number): string => {
    const convertedValue = value.toString()
    const hundredsBreakpoint = convertedValue.length - 3
    const thousandsBreakpoint = convertedValue.length - 4
    const millionsBreakpoint = convertedValue.length - 6

    if (value >= values.oneMillion) {
      const millions = convertedValue.substring(0, millionsBreakpoint)
      const thousands = convertedValue.substring(millionsBreakpoint, thousandsBreakpoint)

      return `${millions}.${thousands}M`
    }

    if (value >= values.tenThousand) {
      return `${convertedValue.substring(0, hundredsBreakpoint)}K`
    }

    return convertedValue
  }
}
